'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refPropType = function refPropType(props, propName, componentName) {
  if (_typeof(props[propName]) === 'object' && props[propName].hasOwnProperty('current')) {
    return null;
  }
  return new Error(componentName + ': Invalid ' + propName + ' value. Expected an object created with React.createRef() or a polyfill.');
};

exports.default = (0, _createChainablePropType2.default)(refPropType, 'ref object');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/propTypes/refObject.js
// module id = 46
// module chunks = 171